define([
    'WebCommon/api',
    'WebCommon/event-bus',
    'WebCommon/events',
    'WebCommon/utils'
], function(
    Api,
    EventBus,
    Events,
    Utils
){
    var user = window.FNJISite?window.FNJISite.user:{};
    var member = {};
    function fetchMemberInfo(){
        if (!user.login){
            member = {};
            emitMemberInfo();
            return;
        }
        Api.getMemberInfoApi.ajax()
            .done(function(data){
                member = data;
                emitMemberInfo();
            });
    }
    function emitMemberInfo(){
        EventBus.$emit(Events.UpdateMemberInfo, member);
    }
    function getMember(){
        return member;
    }
    function getUser(){
        return user;
    }
    function isLoggedIn(){
        return !!user.login;
    }

    function loginRedirect(from){
        console.log(from)
        from = from || Utils.getUrlParam('from') || location.href;
        // window.location.href = decodeURIComponent(from);
        window.location.href = from;

        setTimeout(function () {
            window.location.reload();
        }, 100);

    }
    function login(info, from){
        Api.loginApi.ajax({data_json: JSON.stringify(info)})
            .done(function(){
                loginRedirect(from);
            });
    }
    function logout(){
        Api.logoutApi.ajax()
            .done(function(){
                window.location.reload();
            });
    }

    return {
        fetchMemberInfo: fetchMemberInfo,
        getMember: getMember,
        getUser: getUser,
        isLoggedIn: isLoggedIn,
        loginRedirect: loginRedirect,
        login: login,
        logout: logout
    };
});


//////////////////
// WEBPACK FOOTER
// ../common/auth.js
// module id = 14
// module chunks = 0 1 2 3